export class SaveStatePrescriptionLogInput {
    orderId: number;
    newStatePrescriptionId: number;
    userId?: number;
}